import { render, staticRenderFns } from "./InvoiceProjectModal.vue?vue&type=template&id=28651adc&scoped=true&"
import script from "./InvoiceProjectModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceProjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28651adc",
  null
  
)

export default component.exports